if (!customElements.get('loyalty-link')) {
  customElements.define(
    'loyalty-link',
    class extends HTMLElement {
      constructor() {
        super();
        this.returnUrl = this.dataset.returnUrl || '/';
        this.link = this.querySelector('a');
        this.link.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick() {
        sessionStorage.setItem('post_register_redirect', this.returnUrl);
      }
    }
  );
}
